import {
  FETCH_RENAME_DOCUMENTS_REQUEST,
  FETCH_RENAME_DOCUMENTS_SUCCESS,
  FETCH_RENAME_DOCUMENTS_FALUIRE,
} from './renameDocumentsTypes'

const initialState = {
  loading: false,
  renameDocumentInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_RENAME_DOCUMENTS_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_RENAME_DOCUMENTS_SUCCESS : return {
      ...state,
      renameDocumentInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_RENAME_DOCUMENTS_FALUIRE : return {
      ...state,
      loading: false,
      renameDocumentInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
